function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3 4.414l17.293 17.293 1.414-1.414L4.414 3H14V1H1v13h2zM47 45.586L29.707 28.293l-1.414 1.414L45.586 47H36v2h13V36h-2zM36 3h9.586L28.293 20.293l1.414 1.414L47 4.414V14h2V1H36zM14 47H4.414l17.293-17.293-1.414-1.414L3 45.586V36H1v13h13z"
});

function SvgMaximize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgMaximize;